import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DryEyeFormsService } from '../dry-eye-forms.service';
import { DryEyeFormGroup } from '../dry-eye-form/dry-eye-form.model';
import { NUTRITION_TEST_KEYS, NUTRITION_TEST_SCHEMA } from './nutrition-based-testing.schema';

@Component({
  selector: 'csi-nutrition-based-testing',
  templateUrl: './nutrition-based-testing.component.html',
  styleUrls: ['./nutrition-based-testing.component.scss']
})
export class NutritionBasedTestingComponent implements OnInit {
  @Input() formGroup: DryEyeFormGroup;
  @Input() useAccordion = true;

  public readonly nutritionKeys = NUTRITION_TEST_KEYS;
  public readonly schema = NUTRITION_TEST_SCHEMA;

  constructor(public dryEyeFormsService: DryEyeFormsService) {}

  ngOnInit() {
    this.ensureControls();
  }

  public trackByKey(index: number, key: string): string {
    return key;
  }

  private ensureControls() {
    this.nutritionKeys.forEach(key => {
      if (!this.formGroup.controls[key]) {
        this.formGroup.addControl(key, new FormControl(null));
      }
    });
  }
}
